import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BaseDataService} from '../commons/base-data.service';
import {HelpersService} from '../../core/helpers/helpers.service';
import { AuthorControllerService, AuthorP, PostContentControllerService, PostControllerService, PostGroupControllerService, PostGroupP, PostP } from '../blog-client-api';

@Injectable()
export class BlogDataRestService extends BaseDataService {

  constructor(private authorService: AuthorControllerService,
    private postContentService: PostContentControllerService,
    private postService: PostControllerService,
    private postGroupService: PostGroupControllerService,
              helpers: HelpersService) {
    super(helpers);
  }

  getBlogGroups(): Observable<PostGroupP[]> {
    return this.postGroupService.getByNotNullPost().map(response => {
            return response;
    })
  }


  getBlogGroupById(blogGroupID: number): Observable<PostGroupP> {
    return this.postGroupService.getById1(blogGroupID).map(response => {
        return response;
    })
  }

  getBlogById(blogId: number): Observable<PostP> {
    return this.postService.getById(blogId).map(response => {
        return response;
    })
  }

  getBlogsByAuthor(authorId: number): Observable<AuthorP> {
    return this.authorService.getById3(authorId).map(response => {
        return response;
    })
  }

  likePostContent(postContentId: number): Observable<any> {
    return this.postContentService.likePostContentUsingGET(postContentId).map(response => {
        return true;
    })
  }
  
  dislikePostContent(postContentId: number): Observable<any> {
    return this.postContentService.dislikePostContentUsingGET(postContentId).map(response => {
        return true;
    })
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/blog/blog-data-rest.service.ts